<template>
    <BnOffsetCard :blockTitle="label">
        <v-layout slot="block-elements" row wrap justify-space-between class="pa-4">

            <v-flex md3>
                <v-text-field
                    :value="getValue('irszam')"
                    @keyup="irszamChangeKeyUp($event)"
                    :rules="[
                            (v) => rules.required(
                                v,
                                 'Irányítószám kitöltése kötelező!'
                                 ), (v) => isIrszam(v)
                                 ]"
                    label="Irányítószám"
                    prepend-inner-icon="place"
                    :disabled="!!this.disabled"
                ></v-text-field>
            </v-flex>

            <v-flex md8>
                <v-autocomplete
                    :value="getValue('varos')"
                    @change="varosChange($event)"
                    :rules="[(v) => rules.required(v, 'Város kitöltése kötelező!')]"
                    label="Város"
                    :items="varosLista"
                    item-text="varos"
                    item-value="varoskod"
                    :loading="varosListaLoading"
                    :disabled="!!this.disabled"
                ></v-autocomplete>
            </v-flex>

            <v-flex md12 xs12>
                <v-autocomplete
                    :value="getValue('utca')"
                    @change="setValue($event, 'utca')"
                    :rules="[(v) => rules.required(v, 'Közterület kitöltése kötelező')]"
                    label="Utca"
                    :items="kozteruletLista"
                    item-text="kozterulet"
                    item-value="idkozterulet"
                    :loading="kozterListaLoading"
                    :disabled="!!this.disabled"
                ></v-autocomplete>
            </v-flex>
            <v-flex md8 v-if="egyebLatszik()">
                <v-text-field
                    :value="getValue('egyeb_utcanev')"
                    :rules="[(v)=> rules.required(v, 'Közterület neve megadása kötelező!')]"
                    @change="setValue($event, 'egyeb_utcanev')"
                    @keyup="onKeyUpEgyebUtca($event)"
                    label="Egyéb közterület neve"
                    :disabled="!!this.disabled"
                ></v-text-field>

            </v-flex>
            <v-flex md4 v-if="egyebLatszik()">
                <v-select
                    :value="getValue('egyeb_koztertipus')"
                    :rules="[(v)=> rules.required(v, 'Közterület típusa megadása kötelező!')]"
                    @change="setValue($event, 'egyeb_koztertipus')"
                    label="Egyéb közterület típusa"
                    :items="kozterTipusLista"
                    item-text="koztertipus"
                    item-value="idkoztertipus"
                    :disabled="!!this.disabled"
                ></v-select>
            </v-flex>
            <v-flex md3>
                <v-text-field
                    :value="getValue('hsz_tol')"
                    @change="setValue($event, 'hsz_tol')"
                    :rules="[(v) => rules.required(v, 'Házszám kitöltése kötelező'), (v) => isHszTol(v)]"
                    label="Házszám -tól"
                    :disabled="!!this.disabled"
                ></v-text-field>
            </v-flex>

            <v-flex md3>
                <v-text-field
                    :value="getValue('hsz_ig')"
                    @change="setValue($event, 'hsz_ig')"
                    :rules="[(v) => isHszIg(v)]"
                    label="-ig"
                    :disabled="!!this.disabled"
                ></v-text-field>
            </v-flex>

            <v-flex md3>
                <v-text-field
                    :value="getValue('epulet')"
                    @change="setValue($event, 'epulet')"
                    @keyup="onKeyUpEpulet($event)"
                    :rules="[(v) => isEpulet(v)]"
                    label="Épület"
                    :disabled="!!this.disabled"
                ></v-text-field>
            </v-flex>

            <v-flex md5>
                <v-select
                    :value="getValue('emelet')"
                    @change="setValue($event, 'emelet')"
                    :rules="[(v) => isEmelet(v)]"
                    label="Emelet"
                    item-text="emelet"
                    item-value="idemelet"
                    :items="emeletLista"
                    :disabled="!!this.disabled"
                ></v-select>
            </v-flex>

            <v-flex md5>
                <v-text-field
                    :value="getValue('ajto')"
                    @change="setValue($event, 'ajto')"
                    :rules="[(v) => isAjto(v)]"
                    label="Ajtó"
                    :disabled="!!this.disabled"
                ></v-text-field>
            </v-flex>
        </v-layout>
    </BnOffsetCard>
</template>
<script>
import {
    isAjto,
    isEmelet,
    isEpulet,
    isHszIg,
    isHszTol,
    isIrszam,
} from '../../modules/AddressValidator';
import { required } from '../../modules/Validators';
import { capitalize, capitalizeAllCharacters } from '../../filters/capitalize';
import cimService from '../../services/CimService';
import BnOffsetCard from './BnOffsetCard.vue';

export default {
    components: { BnOffsetCard },
    data() {
        return {
            irszamLoading: true,
            varosLoading: true,
            varosLista: [],
            kozteruletLista: [],
            emeletLista: [],
            kozterTipusLista: [],
            varosListaLoading: false,
            kozterListaLoading: false,
            rules: {
                required,
            },
        };
    },

    props: {
        path: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    computed: {

        irszam() {
            return this.getValue('irszam');
        },

        varos() {
            return this.getValue('varos');
        },
    },

    watch: {
        irszam(val) {
            if (this.irszamLoading) {
                this.varosListaLoading = true;
                cimService.getVarosLista(val).then((response) => {
                    this.varosLista = response.data;
                    this.varosListaLoading = false;
                });
                this.irszamLoading = false;
            }
        },

        varos(varos) {
            if (this.varosLoading) {
                this.kozterListaLoading = true;
                cimService.getKozterLista(`${this.getValue('irszam')}${varos}`).then((response) => {
                    this.kozteruletLista = response.data;
                    this.kozterListaLoading = false;
                });
                this.varosLoading = false;
            }
        },
    },

    methods: {

        isAjto,
        isEmelet,
        isEpulet,
        isHszIg,
        isHszTol,
        isIrszam,

        validate() {
            return [];// errortomb
        },

        onKeyUpEgyebUtca(event) {
            this.setValue(event.target.value, 'egyeb_utcanev');
            const utcanev = capitalize(this.getValue('egyeb_utcanev'));
            this.setValue(utcanev, 'egyeb_utcanev');
        },

        onKeyUpEpulet(event) {
            this.setValue(event.target.value, 'epulet');
            const epulet = capitalizeAllCharacters(this.getValue('epulet'));
            this.setValue(epulet, 'epulet');
        },

        egyebLatszik() {
            return Number(this.getValue('utca')) === -1;
        },

        irszamChangeKeyUp(event) {
            if (event.target.value.length === 4) {
                this.irszamChange(event.target.value);
            }
        },

        irszamChange(irszam) {
            this.setValue(irszam, 'irszam');
            this.varosListaLoading = true;

            cimService.getVarosLista(irszam).then((response) => {
                this.varosLista = response.data;
                this.varosListaLoading = false;

                if (this.varosLista.length === 0) {
                    this.varosLista.push({
                        varoskod: -9999,
                        varos: 'Érvénytelen irányítószám!',
                    });
                }

                // console.log('Egy darab van a városlistába', this.varosLista.length, this.varosLista[0].varoskod)
                // betesszük h eleve ki legyen jelölve h megjelent
                if (this.varosLista.length === 1) {
                    this.setValue(this.varosLista[0].varoskod, 'varos');
                }

                this.varosChange(this.varosLista[0].varoskod);
            });
        },

        varosChange(varos) {
            this.kozterListaLoading = true;
            // console.log('1');
            this.setValue(varos, 'varos');
            // console.log('2' + this.getValue('irszam') + '' + varos);
            cimService.getKozterLista(`${this.getValue('irszam')}${varos}`).then((response) => {
                this.kozteruletLista = response.data;
                this.kozterListaLoading = false;
            });
        },

        getValue(propName) {
            return this.$getNestedPropVal(this.$store.getters, (`${this.path}.${propName}`).split('.'));
        },

        setValue(value, propName) {
            this.$store.commit('setProp', {
                path: `${this.path}.${propName}`,
                value,
            });

            // kitoroljuk az egyebutcanevet ha változik az utca
            if (propName === 'utca') {
                this.$store.commit('setProp', {
                    path: `${this.path}.egyeb_utcanev`,
                    value: '',
                });

                this.$store.commit('setProp', {
                    path: `${this.path}.egyeb_koztertipus`,
                    value: 0,
                });
            }
        },

        getKoztertipusLista() {
            cimService.getKozterTipusLista().then((response) => {
                this.kozterTipusLista = response.data;
            });
        },

        getEmeletLista() {
            cimService.getEmeletLista().then((response) => {
                this.emeletLista = response.data;
            });
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.$validator.addValidator(this.validate);

            /* this.setValue(this.getValue('irszam'), 'irszam');
                this.setValue(this.getValue('varos'), 'varos');
                this.setValue(this.getValue('utca'), 'utca');
                this.setValue(this.getValue('hsz_tol'), 'hsz_tol');
                this.setValue(this.getValue('hsz_ig'), 'hsz_ig');
                this.setValue(this.getValue('epulet'), 'epulet');
                this.setValue(this.getValue('emelet'), 'emelet');
                this.setValue(this.getValue('ajto'), 'ajto');

                if(!!this.egyebLatszik()) {
                    this.setValue(this.getValue('egyeb_utcanev'), 'egyeb_utcanev');
                    this.setValue(this.getValue('egyeb_koztertipus'), 'egyeb_koztertipus');
                }
                console.log('valami: '+this.getValue('irszam') + '' + varos); */
            // /frissítjuk a listát
            // console.log('valami: '+this.getValue('irszam'));
            this.irszamChange(this.getValue('irszam'));
            // this.varosChange(this.getValue('varos'));

            this.getKoztertipusLista();
            this.getEmeletLista();
        });
    },
};
</script>
